export enum MutationTypes {
  SET_IS_LOADING = 'setIsLoading',
  GET_IS_LOADING = 'getIsLoading',
}
